export default "__VITE_PUBLIC_ASSET__1609c7a6__"